import { useContext } from 'react'

import CustomerInfoContext, { AuthenticatedCustomerInfoContext } from 'contexts/CustomerInfoContext'

export const useCustomerInfo = (): AuthenticatedCustomerInfoContext => {
  return useContext(CustomerInfoContext)
}
